import React from 'react';
import './AdminBookCard.css';

function getLinks(book, platform) {
  const listKey = platform === 'youtube' ? 'youtube_links' : 'rumble_links';
  const singleKey = platform === 'youtube' ? 'youtube_link' : 'rumble_link';
  const links = book[listKey];
  if (Array.isArray(links) && links.length > 0) {
    return links.filter(Boolean);
  }
  return book[singleKey] ? [book[singleKey]] : [];
}

function AdminBookCard({ book, onEdit, onDelete }) {
  const youtubeLinks = getLinks(book, 'youtube');
  const rumbleLinks = getLinks(book, 'rumble');

  return (
    <div className="admin-book-card">
      <div className="admin-book-content">
        {book.cover_image_url && (
          <div className="admin-book-cover-container">
            <img 
              src={book.cover_image_url} 
              alt={`${book.name} cover`}
              className="admin-book-cover-image"
              loading="lazy"
            />
          </div>
        )}
        <div className="admin-book-details">
          <h3>{book.name || 'Untitled Book'}</h3>
          {book.featured && <p className="admin-featured-badge">Featured</p>}
          <p><strong>Author:</strong> {book.author || 'Unknown'}</p>
          <p><strong>Genre:</strong> {book.genre || 'N/A'}</p>
          <p><strong>Parts:</strong> {book.parts ?? 'N/A'}</p>
          <p><strong>Published:</strong> {book.publish_year ?? 'N/A'}</p>
          <p><strong>Uploaded:</strong> {book.uploaded_date || 'N/A'}</p>
          <p>
            <strong>YouTube:</strong>{' '}
            {youtubeLinks.length > 0
              ? youtubeLinks.map((url, i) => (
                  <span key={`yt-${i}`}>
                    {i > 0 && ', '}
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      Part {i + 1}
                    </a>
                  </span>
                ))
              : '—'}
          </p>
          <p>
            <strong>Rumble:</strong>{' '}
            {rumbleLinks.length > 0
              ? rumbleLinks.map((url, i) => (
                  <span key={`rb-${i}`}>
                    {i > 0 && ', '}
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      Part {i + 1}
                    </a>
                  </span>
                ))
              : '—'}
          </p>
        </div>
      </div>
      <div className="admin-book-actions">
        <button
          type="button"
          className="edit-button"
          onClick={() => onEdit(book)}
        >
          Edit
        </button>
        <button
          type="button"
          className="delete-button"
          onClick={() => onDelete(book.id)}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default AdminBookCard;
